(() => {
  if (window.CTEDestinationRoutes) return;
  function mount(root) {
    if (root.dataset.ready) return;
    const cards = Array.from(root.querySelectorAll('[data-destination-route]'));
    const controls = root.querySelector('[data-ct-route-controls]');
    const search = root.querySelector('[data-ct-route-search]');
    const vessel = root.querySelector('[data-ct-route-vessel]');
    const count = root.querySelector('[data-ct-route-count]');
    const more = root.querySelector('[data-ct-route-more]');
    const empty = root.querySelector('[data-ct-route-empty]');
    if (!cards.length || !controls || !search || !vessel || !count || !more || !empty) return;
    root.dataset.ready = 'true';
    let visibleLimit = 6;
    const normalise = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const entries = cards.map(card => ({ card, vessel: card.dataset.routeVessel, text: normalise(card.dataset.routeSearch || card.textContent) }));
    const vessels = [...new Set(entries.map(entry => entry.vessel).filter(Boolean))].sort((a, b) => a.localeCompare(b));
    for (const name of vessels) {
      const option = document.createElement('option');
      option.value = name; option.textContent = name; vessel.append(option);
    }
    function update() {
      const terms = normalise(search.value.trim()).split(/\s+/).filter(Boolean);
      const matches = entries.filter(entry => (!vessel.value || entry.vessel === vessel.value) && terms.every(term => entry.text.includes(term)));
      const shown = new Set(matches.slice(0, visibleLimit));
      entries.forEach(entry => { entry.card.hidden = !shown.has(entry); });
      count.textContent = `${Math.min(visibleLimit, matches.length)} of ${matches.length} routes shown`;
      empty.hidden = matches.length !== 0;
      more.hidden = visibleLimit >= matches.length;
      more.textContent = `Show ${Math.min(6, Math.max(0, matches.length - visibleLimit))} more routes`;
      return matches;
    }
    const reset = () => { visibleLimit = 6; update(); };
    search.addEventListener('input', reset);
    vessel.addEventListener('change', reset);
    more.addEventListener('click', () => {
      const firstNew = visibleLimit; visibleLimit += 6;
      const matches = update();
      const target = matches[firstNew]?.card.querySelector('h3 a');
      if (target) target.focus({ preventScroll: true });
    });
    update(); controls.hidden = cards.length <= 1;
  }
  function init(scope = document) {
    if (scope.matches?.('[data-ct-route-list]')) mount(scope);
    scope.querySelectorAll('[data-ct-route-list]').forEach(mount);
  }
  window.CTEDestinationRoutes = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
